import { styled } from '@mui/material/styles';
import { Check } from '@mui/icons-material';

export const CheckIconStyled = styled(Check, {
  name: 'CheckIconStyled',
})(({ theme }) => ({
  color: theme.palette.success.main,
}));
